import { render, staticRenderFns } from "./FieldsReasonOfTerminationCost.vue?vue&type=template&id=4a927b15&"
import script from "./FieldsReasonOfTerminationCost.vue?vue&type=script&lang=js&"
export * from "./FieldsReasonOfTerminationCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports